import React from "react";
import PageConverter from "../../Function/PageConverter";
import jsonData from "./RegisterCandidateBiography.json";

const RegisterCandidateBiography = () => {
  return (
    <>
      <PageConverter jsonData={jsonData} />
    </>
  );
};

export default RegisterCandidateBiography;
